import { combineReducers } from 'redux'
import { LOGIN_DATA , FACEBOOK_LOGIN,LOGIN_TWITTER_DATA,LOGIN_STARTUP_INDIA_DATA} from '../../../common/constants/actionConstants'


const getLoginData = (state = [], action) => {
    switch (action.type) {
        case LOGIN_DATA:
        return { ...action.payload }

      default:
        return state
    }
  }
  const getFacebookLoginData = (state = [], action) => {
    switch (action.type) {
      case FACEBOOK_LOGIN:
        return { ...action.payload }
      default:
        return state;
    }
  };
  const getTwitterLoginData = (state = [], action) => {
    switch (action.type) {
      case LOGIN_TWITTER_DATA:
        return { ...action.payload }
      default:
        return state;
    }
  };
  
  const getStartupIndiaLoginData = (state = [], action) => {
    switch (action.type) {
      case LOGIN_STARTUP_INDIA_DATA:
        return { ...action.payload }
      default:
        return state;
    }
  };
  const LoginpageReducer = combineReducers({
    getLoginData,
    getFacebookLoginData,
    getTwitterLoginData,
    getStartupIndiaLoginData,
  })
  
  export default LoginpageReducer;
  